
var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedworkflow",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_who: null,

	sayViewing: sayViewing
});

function init() {
	this.push({
		ongoing: {},
		history: {},
		actions: {},
		definition: {},
		create: {},
		details: null,
		edit: {},
		externals: {}
	});
}

function listeners() {
	return {
		"managedongoingworkflow:updated": Model.makeExtender("ongoing"),
		"managedhistoryworkflow:updated": Model.makeExtender("history"),
		"managedactionsworkflow:updated": Model.makeExtender("actions"),
		"manageddefinitionworkflow:updated": Model.makeExtender("definition"),
		"managedcreateworkflow:updated": Model.makeExtender("create"),
		"managededitingworkflow:updated": Model.makeExtender("edit"),
		"activemanagedworkflow:updated": Model.makeExtender("details"),
		"managedworkflowexternals:updated": Model.makeExtender("externals"),
	};
}

function triggers() {
	return {
		"view": view,
		"details": details,
		"reset": reset
	};
}

function details(data){
	var who = this._who;
	if(!who) return;
	this.emit("activemanagedworkflow:trigger:view", {
		workflow: data.workflow,
		history: data.history,
		who: who,
		group: data.group
	});

	this.emit("usermetrics:trigger:track", "view managed user's pathway details", {
		who: who
	});
}

function view(data) {
	this._who = data.who;

	this.emit("managedongoingworkflow:trigger:load", data);
	this.emit("managedhistoryworkflow:trigger:load", data);

	this.sayViewing();

	this.emit("usermetrics:trigger:track", "view managed user's pathway", {
		who: this._who
	});
}

function reset() {
	this.emit("managedongoingworkflow:trigger:reset");
	this.emit("managedhistoryworkflow:trigger:reset");
	this.emit("usermetrics:trigger:track", "close managed user's pathway", {
		who: this._who
	});
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who
	});
}
